/* eslint-disable */
// @ts-nocheck
// IMPORTANTE: este módulo precisa ser o PRIMEIRO import da aplicação.
// Ajusta o publicPath do webpack em runtime para que os assets (imagens,
// fontes) carreguem sempre a partir da URL pública do app (dev server ou
// internalUrl de produção), e não da origem do portal xvia — que é outra
// origem quando o bundle roda embarcado no portal (ex.: localhost:7004).
// Sem isso, /<hash>.png é pedido na origem do portal e dá 404 (logo quebrada).
// Usamos REACT_APP_ASSET_BASE (injetada nativamente pelo CRA) em vez de
// PUBLIC_URL, que sofre conflito de definição com o react-scripts e chega
// vazia no bundle. Fallback para PUBLIC_URL caso a primeira não exista.
var assetBase = process.env.REACT_APP_ASSET_BASE || process.env.PUBLIC_URL;
if (assetBase) {
    __webpack_public_path__ = assetBase.replace(/\/?$/, "/");
}
export {};
